// extracted by mini-css-extract-plugin
export var alignBaseline = "_5-9";
export var alignCenter = "_5-5";
export var alignFlexEnd = "_5-7";
export var alignFlexStart = "_5-6";
export var alignSelfBaseline = "_5-e";
export var alignSelfCenter = "_5-a";
export var alignSelfFlexEnd = "_5-c";
export var alignSelfFlexStart = "_5-b";
export var alignSelfStretch = "_5-d";
export var alignStretch = "_5-8";
export var column = "_5-2";
export var columnReverse = "_5-4";
export var flex = "_5-0";
export var justifyCenter = "_5-f";
export var justifyFlexEnd = "_5-h";
export var justifyFlexStart = "_5-g";
export var justifySpaceAround = "_5-j";
export var justifySpaceBetween = "_5-i";
export var justifySpaceEvenly = "_5-k";
export var row = "_5-1";
export var rowReverse = "_5-3";
export var wrapNowrap = "_5-m";
export var wrapWrap = "_5-l";
export var wrapWrapReverse = "_5-n";